import React from 'react';
import './FAQPage.scss';

const FAQPage = () => {
    return (
        <main className="page page--faq" aria-labelledby="faq-title">
            <div className="page__inner">
                <h1 id="faq-title" className="page__title">Frequently Asked Questions</h1>
                <p className="page__intro">
                    Everything you need to know about Plan My Guest. If you can’t find an answer here,
                    just reach out to us. We’re happy to help.
                </p>

                <dl className="faq">
                    <div className="faq__item">
                        <dt>What is Plan My Guest?</dt>
                        <dd>Plan My Guest is a modern wedding guest management
                            platform that helps couples handle everything from
                            creating a customized designed wedding website to, send
                            wedding invitations, managing RSVPs, seating, and guest
                            lists that all in one elegant, easy-to-use place.</dd>
                    </div>
                    <div className="faq__item">
                        <dt>Do I need any technical skills to use it?</dt>
                        <dd>Not at all!. Our platform is designed to be simple and
                            intuitive. If you can browse a website, you can use Plan My
                            Guest effortlessly. We handle the setup so you can focus on
                            planning your big day</dd>
                    </div>
                    <div className="faq__item">
                        <dt>How do guests RSVP?</dt>
                        <dd>Your guests will receive a link to your wedding website,
                            where they can RSVP online in seconds. no paper, no
                            confusion.
                        </dd>
                    </div>
                    <div className="faq__item">
                        <dt>Can I track who’s attending and who’s not?</dt>
                        <dd>Absolutely! You’ll see live updates of all responses in your
                            dashboard, including who’s attending, who hasn’t replied,
                            and who’s declined. You can even track special
                            preferences like who’s taking liquor to help
                            with catering planning.
                        </dd>
                    </div>
                    <div className="faq__item">
                        <dt>What if my guest list changes?</dt>
                        <dd>No problem at all! You can add, or remove guests anytime.
                            Your statistics will update instantly to reflect the latest
                            numbers.
                        </dd>
                    </div><div className="faq__item">
                        <dt>Do you offer support if I need help?</dt>
                        <dd>Yes definitely. our friendly team is always here to help! You
                            can contact us via whatsapp chat, and we’ll assist you
                            every step of the way
                        </dd>
                    </div><div className="faq__item">
                        <dt>Can I upgrade my package later?</dt>
                        <dd>Of course! You can start small and upgrade anytime if you
                            need more features or guest capacity. It’s completely
                            flexible.
                        </dd>
                    </div><div className="faq__item">
                        <dt>How secure is my guest data?</dt>
                        <dd>We take privacy seriously. All your information is stored
                            securely and never shared with third parties. Only you
                            have access to your guest data.
                        </dd>
                    </div><div className="faq__item">
                        <dt>How soon can I get started?</dt>
                        <dd>Right away! Once you choose your package, we’ll set up your
                            account and send your wedding website link within 24–48
                            hours.
                        </dd>
                    </div><div className="faq__item">
                        <dt>How long will my wedding website be available?</dt>
                        <dd>Your personalized wedding website will remain active for
                            two months from the date it’s published. giving you and
                            your guests plenty of time to RSVP, view details, and stay
                            connected before the big day.
                        </dd>
                    </div><div className="faq__item">
                        <dt>Do guests need to create an account to RSVP?</dt>
                        <dd>Nope! Your guests can RSVP directly through your wedding
                            website. quick, easy, and stress-free. No logins, no apps, just
                            one simple click.
                        </dd>
                    </div>
                </dl>

                <a href="/" className="page__back">← Back to Home</a>
            </div>
        </main>
    );
};

export default FAQPage;
